// extracted by mini-css-extract-plugin
export var cancelButton = "_mf-5";
export var content = "_mf-3";
export var createButton = "_mf-6";
export var drawerContainer = "_mf-0";
export var footer = "_mf-2";
export var header = "_mf-1";
export var orderFormColumn = "_mf-4";